import { useLayoutEffect, useRef } from 'react';
import { gsap } from 'gsap';

const originalPositions = [
  { cx: 3.691, cy: 10, opacity: 1 },
  { cx: 10, cy: 0.537, opacity: 1 },
  { cx: 10, cy: 6.846, opacity: 1 },
  { cx: 10, cy: 13.154, opacity: 1 },
  { cx: 10, cy: 3.692, opacity: 1 },
  { cx: 10, cy: 10, opacity: 1 },
  { cx: 10, cy: 16.308, opacity: 1 },
  { cx: 10, cy: 19.463, opacity: 1 },
  { cx: 16.308, cy: 10, opacity: 1 },
  { cx: 0.537, cy: 10, opacity: 1 },
  { cx: 6.846, cy: 10, opacity: 1 },
  { cx: 13.154, cy: 10, opacity: 1 },
  { cx: 19.463, cy: 10, opacity: 1 },
];

const PlusSubmitIcon = ({ isLoading, ...props }) => {
  const svgRef = useRef(null);
  const groupRef = useRef(null);
  const animation = useRef(null);

  useLayoutEffect(() => {
    const circles = gsap.utils.toArray(
      svgRef.current.querySelectorAll('circle')
    );

    if (animation.current) {
      animation.current.kill();
    }

    if (isLoading) {
      animation.current = gsap.timeline();
      const radius = 6.5;
      const center = 10;
      const numVisibleDots = 9;
      const arcAngle = 1.6 * Math.PI;

      circles.forEach((circle, i) => {
        if (i < numVisibleDots) {
          const angle = (i / numVisibleDots) * arcAngle;
          const targetX = center + radius * Math.cos(angle);
          const targetY = center + radius * Math.sin(angle);

          animation.current.to(
            circle,
            {
              attr: { cx: targetX, cy: targetY },
              opacity: 1,
              duration: 0.5,
              ease: 'power3.inOut',
            },
            0
          );
        } else {
          animation.current.to(
            circle,
            {
              opacity: 0,
              duration: 0.4,
              ease: 'power2.out',
            },
            0
          );
        }
      });

      animation.current.to(
        groupRef.current,
        {
          rotation: 360,
          transformOrigin: 'center center',
          duration: 1,
          ease: 'none',
          repeat: -1,
        },
        '>-0.2'
      );
    } else {
      animation.current = gsap.timeline();

      circles.forEach((circle, i) => {
        animation.current.to(
          circle,
          {
            attr: { cx: originalPositions[i].cx, cy: originalPositions[i].cy },
            opacity: originalPositions[i].opacity,
            duration: 0.5,
            ease: 'power3.inOut',
          },
          0
        );
      });

      gsap.set(groupRef.current, { rotation: 0 });
    }

    return () => {
      if (animation.current) {
        animation.current.kill();
      }
    };
  }, [isLoading]);

  return (
    <svg
      ref={svgRef}
      xmlns='http://www.w3.org/2000/svg'
      width={20}
      height={20}
      fill='none'
      {...props}
    >
      <g ref={groupRef}>
        <circle cx={3.691} cy={10} r={0.537} fill='#FEFDFB' />
        <circle cx={10} cy={0.537} r={0.537} fill='#FEFDFB' />
        <circle cx={10} cy={6.846} r={0.537} fill='#FEFDFB' />
        <circle cx={10} cy={13.154} r={0.537} fill='#FEFDFB' />
        <circle cx={10} cy={3.692} r={0.537} fill='#FEFDFB' />
        <circle cx={10} cy={10} r={0.537} fill='#FEFDFB' />
        <circle cx={10} cy={16.308} r={0.537} fill='#FEFDFB' />
        <circle cx={10} cy={19.463} r={0.537} fill='#FEFDFB' />
        <circle cx={16.308} cy={10} r={0.537} fill='#FEFDFB' />
        <circle cx={0.537} cy={10} r={0.537} fill='#FEFDFB' />
        <circle cx={6.846} cy={10} r={0.537} fill='#FEFDFB' />
        <circle cx={13.154} cy={10} r={0.537} fill='#FEFDFB' />
        <circle cx={19.463} cy={10} r={0.537} fill='#FEFDFB' />
      </g>
    </svg>
  );
};

export default PlusSubmitIcon;
